import { render, staticRenderFns } from "./compatibility-drawer.vue?vue&type=template&id=6bda6c0c"
import script from "./compatibility-drawer.vue?vue&type=script&lang=js"
export * from "./compatibility-drawer.vue?vue&type=script&lang=js"
import style0 from "./compatibility-drawer.vue?vue&type=style&index=0&id=6bda6c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports